module.exports = __webpack_public_path__ + "static/media/voice.709d60e8.gif";